import { render, staticRenderFns } from "./ForgotModal.vue?vue&type=template&id=3c94f68b&scoped=true&"
import script from "./ForgotModal.vue?vue&type=script&lang=js&"
export * from "./ForgotModal.vue?vue&type=script&lang=js&"
import style0 from "./ForgotModal.vue?vue&type=style&index=0&id=3c94f68b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c94f68b",
  null
  
)

export default component.exports